var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-navbar'),_c('div',{staticClass:"py-14"},[_c('router-view')],1),_c('bottom-navbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }